// extracted by mini-css-extract-plugin
export default {"bordergreen":"#013a4c","ColorBubble":"_ColorBubble--DPfD2","Disabled":"_Disabled--NESb_"};